module.exports = __webpack_public_path__ + "media/images/top/top_md-7541f2b25c03dfb2d3ddeedc21afb6fa.jpg";